<div class="error-container" [ngClass]="containerClasses">
    <div class="documents-comparison">
        <div class="document document-left"></div>
        <div class="document document-right"></div>

        <div class="connection-area">
            <div class="connection-line"></div>
            <div class="connection-particle particle-1"></div>
            <div class="connection-particle particle-2"></div>
            <div class="connection-particle particle-3"></div>
            <div class="connection-particle particle-4"></div>
            <div class="error-symbol"></div>
        </div>
    </div>

    @if (showText) {
    <div class="error-text">{{ text }}</div>
    }

    <!-- Content projection slot for custom templates -->
    <ng-content></ng-content>
</div>
